module.exports = __webpack_public_path__ + "img/icon-step-7.73519501.png";